import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { LoginService } from '@app/core/openid/login.service';
import { ModalConfirmacaoComponent } from '@app/shared/modal-confirmacao/modal-confirmacao.component';

export class ModalConfirmacaoSair {
  public static openModal(
    modalService: NgbModal,
    loginService: LoginService
  ): void {
    const modalConfirmacao = modalService.open(ModalConfirmacaoComponent, {
      ariaLabelledBy: 'modal-basic-title',
      centered: true,
      backdrop: 'static',
      keyboard: false,
    });

    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    modalConfirmacao.componentInstance.confirmarCallback = () =>
      loginService.logout();
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    modalConfirmacao.componentInstance.mensagem =
      'Você está prestes a sair do sistema.';
    modalConfirmacao.componentInstance.btConfirmacao = 'Sim, desejo sair';
    modalConfirmacao.componentInstance.btRecusa = 'Não, quero ficar';
  }
}
